import type { ComboboxOption } from "@rumbledirect/ui-v2";

/**
 * Dutch labels for the repair types (`RepairType` on the backend), keyed by
 * enum value. `RepairType` has no `#[ApiResource]` enum collection (unlike
 * `CauseOfDamage`/`DamageFromDirection`/`TypeOfDamage`), so its cases are
 * translated from the backend's own Dutch strings
 * (`translations/messages.nl.yaml`, `RepairType.SMART_REPAIR`) rather than
 * through `useLabels`. Shared by the overview and reporting filters and the
 * reporting chart.
 */
export const REPAIR_TYPE_LABELS: Readonly<Record<string, string>> = {
  "smart-repair": "SMART Repair",
};

/** The Herstelmethode filter's options, in the order of {@link REPAIR_TYPE_LABELS}. */
export const REPAIR_TYPE_OPTIONS: readonly ComboboxOption[] = Object.entries(
  REPAIR_TYPE_LABELS,
).map(([value, label]) => ({ value, label }));
